import { authService } from 'services';

export const FETCH_ACCOUNT_BEGIN = 'account/FETCH_BEGIN';
export const FETCH_ACCOUNT_SUCCESS = 'account/FETCH_SUCCESS';
export const FETCH_ACCOUNT_ERROR = 'account/FETCH_ERROR';

export const REVERT_SYSTEM_BEGIN = 'account/REVERT_SYSTEM_BEGIN';
export const REVERT_SYSTEM_END = 'account/REVERT_SYSTEM_END';

export function fetchAccountBegin(){
    return {
        type: FETCH_ACCOUNT_BEGIN
    }
}

export function fetchAccountSuccess(account){
    return {
        type: FETCH_ACCOUNT_SUCCESS,
        account: account
    }
}

export function fetchAccountError(error){
    return {
        type: FETCH_ACCOUNT_ERROR,
        error: error
    }
}

export function revertSystemBegin(){
    return {
        type: REVERT_SYSTEM_BEGIN
    }
}

export function revertSystemEnd(){
    return {
        type: REVERT_SYSTEM_END
    }
}

export function fetchAccount(){
    return (dispatch)=>{
        dispatch(fetchAccountBegin());

        return authService().getAccount().then((res)=>{
            dispatch(fetchAccountSuccess(res.data));
        }).catch((error)=> {
            return dispatch(fetchAccountError('Cannot load info about your account right now.Please try later'));
        });

    }
}

export function updateAccount(account){
    return (dispatch)=>{
        dispatch(fetchAccountBegin());
        document.getElementById("save-changes").innerText = "Saving...";
        authService().updateAccount(account).then(()=>{
            dispatch(fetchAccount());
            if (typeof window !== "undefined"){
                location.reload();
            }
        }).catch((e)=>{
            if (e){
                alert('Cannot save changes at the moment. If the error persist, please contact our support team.');
            }
            document.getElementById("save-changes").innerHTML = `<i class="fa fa-check"></i>&nbsp;Save`;
        });
    }
}


export function deleteAccount(){
    return (dispatch)=>{
        dispatch(fetchAccountBegin());
        authService().deleteAccount().then(()=>{
            dispatch(fetchAccount());
        }).catch(()=>{
            dispatch(fetchAccount());
        });
    }
}

export function revertSystem(date, locationId){
    return (dispatch)=>{
        dispatch(revertSystemBegin());
        authService().revertSystem({date, locationId}).then(()=>{
            dispatch(revertSystemEnd());
            setTimeout(()=>{
                window.location.reload(true);
            }, 200)
        }).catch(()=>{
            dispatch(revertSystemEnd());
        });
    }
}

export function testGoogleDrive(){
    return ()=>{
        return authService().testGoogleDrive().then(res => res.data);
    }
}

export function testFtp(data){
    return ()=>{
        return authService().testFtp(data).then(res => res.data);
    }
}

export function testSmtp(data){
    return ()=>{
        return authService().testSmtp(data).then(res => res.data);
    }
}

const DEFAULT_THEME_SETTINGS = {
    font: '', invoiceTitle: '', dateFormat: 'DD/MM/YYYY', decimalPlaces: 2,
    paymentTerms: '', thankYouText: '',
    showShipping: true, showBankDetails: true, showPaidBadge: true,
    showNotes: true, showTracking: true, showTerms: false,
    showSignatureLines: false, showQrCode: false, showTaxColumns: false,
    showSku: true, showImages: false, showDiscount: true,
    showWeight: false, showHsCode: false, showSubtotal: true,
    showTaxBreakdown: true, showShippingCost: true, showDueDate: false,
    mergeDiscounts: false, showOrderDiscountAsSummary: false,
};

function normalizeThemes(account) {
    if (account && account.themes) {
        account.themes = account.themes.map(theme => ({
            ...theme,
            settings: { ...DEFAULT_THEME_SETTINGS, ...(theme.settings || {}) }
        }));
    }
    return account;
}

const reducer = (state = {
}, action={}) => {
  switch(action.type){
    case FETCH_ACCOUNT_BEGIN:
        return {
            ...state,
            fetching: true,
        };
    case FETCH_ACCOUNT_SUCCESS:
        return {
            ...state,
            fetching: false,
            ...normalizeThemes(action.account)
        };
    case FETCH_ACCOUNT_ERROR:
        return {
            ...state,
            fetching: false,
            error: action.error
        };
    case REVERT_SYSTEM_BEGIN:
        return {
            ...state,
            reverting: true
        }
    case REVERT_SYSTEM_END:
        return {
            ...state,
            reverting: false
        }
    default:
        return state;
  }
}

export default reducer;


// WEBPACK FOOTER //
// app/modules/account.js